/**
 * The /lms/courses/:courseId/learn route element (plan docs/plans/lms-plan.md
 * 7.2, 7.3, 18.3; WP-40): the course player. LmsApp routes to this file's
 * DEFAULT export; the course id is useParams().courseId (18.3). The player is
 * the one screen that uses the content area edge to edge (G13), so this page
 * does not wrap itself in lmsPageCls.
 */
import { Navigate, useParams } from 'react-router-dom';
import { Player } from '../../components/player/Player';

export function LearnPage() {
  const { courseId } = useParams();
  if (!courseId) return <Navigate to="/lms/courses" replace />;
  return <Player courseId={courseId} />;
}

export default LearnPage;
